import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@roc/ui';
import React from 'react';

export const TASK_SCOPE_INTERNAL_COLOR = 'rgb(72, 173, 37)';
export const TASK_SCOPE_EXTERNAL_COLOR = 'rgb(217, 68, 82)';
const DEFAULT_SIZE = 16;
const BACKGROUND_OPACITY = 0.12;

const toScopeStyles = (color: string) => {
  const match = color.match(/\d+/g);

  if (!match || match.length < 3) {
    return {
      color,
      borderColor: color,
      backgroundColor: color,
    };
  }

  const [r, g, b] = match;

  return {
    color,
    borderColor: color,
    backgroundColor: `rgba(${r}, ${g}, ${b}, ${BACKGROUND_OPACITY})`,
  };
};

const useStyles = makeStyles({
  scopeIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: '50%',
    borderWidth: 1,
    borderStyle: 'solid',
    fontWeight: 600,
    lineHeight: 1,
    marginLeft: 4,
    marginRight: 2,
    userSelect: 'none',
  },
});

interface TaskScopeIconProps {
  isInternal: boolean;
  color?: string;
  size?: number;
}

export const TaskScopeIcon: React.FC<TaskScopeIconProps> = ({
  isInternal,
  color,
  size = DEFAULT_SIZE,
}) => {
  const classes = useStyles();
  const label = isInternal ? 'Internal Team' : 'External Team';
  const letter = isInternal ? 'I' : 'E';
  const scopeColor = color ?? (isInternal ? TASK_SCOPE_INTERNAL_COLOR : TASK_SCOPE_EXTERNAL_COLOR);
  const scopeStyles = toScopeStyles(scopeColor);
  const fontSize = Math.round(size * 0.625);

  return (
    <Tooltip title={label} placement="top">
      <span
        className={classes.scopeIcon}
        style={{
          width: size,
          height: size,
          fontSize,
          ...scopeStyles,
        }}
        aria-label={label}
      >
        {letter}
      </span>
    </Tooltip>
  );
};
